"use client";

import { ChevronRightSvg } from "@/public/svg";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { twMerge } from "tailwind-merge";

export default function Breadcrumbs({
  datas = [
    {
      title: "Level 1",
      uri: "/",
    },
  ],
}) {
  const router = useRouter();
  return (
    <div>
      <ul className='flex items-center'>
        {datas?.map((item, index) => {
          const isLastItem = index + 1 == datas?.length;
          const colorText = isLastItem ? "greyscale" : "primary";
          return (
            <li
              key={index}
              className='flex justify-center items-center'>
              <Link
                aria-label={`${item?.title}`}
                as={!isLastItem ? item?.uri ?? "/" : "/"}
                shallow
                href={!isLastItem ? item?.uri ?? "/" : "/"}
                className={twMerge(
                  isLastItem ? "cursor-not-allowed" : "cursor-pointer",
                  `p2-medium text-${colorText}GON-400 capitalize`
                )}>
                {item?.title}
              </Link>
              {!isLastItem && (
                <div className={`p-2 text-primaryGON-400`}>
                  <ChevronRightSvg className={`h-6 w-6`} />
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
